class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			const baseUrl = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`;

			const load = (url) => fetch(url)
				.then(response => response.text())
				.then(text => new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]'));

			const render = (innerHTML) => {
				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.innerHTML;
					this.initCarousel();
					return true;
				}
				return false;
			};

			load(`${baseUrl}&intent=complementary`)
				.then(innerHTML => {
					if ( render(innerHTML) ) return;
					return load(`${baseUrl}&intent=related`).then(innerHTML2 => render(innerHTML2));
				});
		}
	}

	initCarousel() {
		const scroll = this.querySelector('[data-js-ctl-scroll]');
		const prev = this.querySelector('[data-js-ctl-prev]');
		const next = this.querySelector('[data-js-ctl-next]');
		if ( ! scroll || ! prev || ! next ) return;

		const step = () => {
			const card = scroll.querySelector('.ctl-card');
			if ( ! card ) return 200;
			const gap = parseFloat(getComputedStyle(scroll).columnGap || getComputedStyle(scroll).gap || '10');
			return card.getBoundingClientRect().width + (isNaN(gap) ? 10 : gap);
		};

		prev.addEventListener('click', () => scroll.scrollBy({ left: -step(), behavior: 'smooth' }));
		next.addEventListener('click', () => scroll.scrollBy({ left: step(), behavior: 'smooth' }));

		const update = () => {
			prev.disabled = scroll.scrollLeft <= 0;
			next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
		};

		scroll.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);

		// The drawer is display:none while recommendations load, so measurements are 0.
		// Re-measure as soon as the carousel becomes visible (drawer opens).
		if ( 'IntersectionObserver' in window ) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if ( entry.isIntersecting ) update();
				});
			});
			observer.observe(scroll);
		}

		update();
	}
}
customElements.define('cart-recommendations', CartRecommendations);